import React from 'react';
import { TeamGrid, teamMembers } from './TeamSection';

const About = () => {
  return (
    <section className="about-section about-team-section" id="nosotros" data-testid="about-team-section">
      <div className="about-team-container">
        <div className="about-team-text">
          <h2 className="about-title">Un equipo familiar a tu servicio.</h2>
          <p className="about-text">
            Somos madre e hija colegas. Sabemos que detrás de cada consulta hay una historia real, con miedos y un futuro que proteger.
          </p>
          <p className="about-text">
            Unimos trayectoria e innovación para darte escucha, soluciones claras y respaldo cuando más lo necesitás.
          </p>
        </div>
        <div id="equipo" className="about-team-cards">
          <TeamGrid members={teamMembers} className="about-team-grid" />
        </div>
      </div>
    </section>
  );
};

export default About;
